import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { FilterBarTagModule } from '@shared/magic-filter-bar/filter-bar-tag/filter-bar-tag.module';
import { FilterPipesModule } from '@shared/filters/pipes/filter-pipes.module';
import { AirFilterBarSlideComponent } from '@shared/magic-filter-bar/air-filter-bar-slide/air-filter-bar-slide.component';
import { AirFilterBarService } from '@shared/magic-filter-bar/air-filter-bar/services/air-filter-bar.service';

@NgModule({
  declarations: [
    AirFilterBarSlideComponent
  ],
  imports: [
    CommonModule,
    GlobalPipesModule,
    TranslocoModule,
    FilterBarTagModule,
    FilterPipesModule,
  ],
  exports: [
    AirFilterBarSlideComponent
  ],
  providers: [
    AirFilterBarService,
  ]
})
export class AirFilterBarSlideModule { }
